module.exports = __webpack_public_path__ + "static/media/ELS22M67.3d366d2d.png";